import React, { useState, useContext, useEffect } from 'react'
import ProductFieldsView from '@/product/components/organisms/Template/Product/FieldsView'
import { dateTimeFormatFunction } from '@/product/common/components'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import * as Yup from 'yup'
import { useHistory } from 'react-router-dom'
import Layout from '@/product/components/templates/Layout'

const DynamicListing = (props) => {
    const dynamicContext = useContext(DynamicContext)

    const { project_dynamicfields } = dynamicContext

    const [updatedValues, setUpdatedValues] = useState({})
    const history = useHistory()

    const [fieldValue, setFieldValue] = useState([])
    const [data, setData] = useState({
        popup: false,
        status: 'newTemplate',
        id: 0,
        projectType: 0,
    })

    useEffect(() => {
        if (props?.match?.params?.id && props?.match?.params?.status) {
            setData({
                popup: true,
                status: props?.match?.params?.status,
                id: props?.match?.params?.id,
                projectType: 0,
            })
        }
    }, [props?.match?.params?.id, props?.match?.params?.status])

    useEffect(() => {
        if (project_dynamicfields && project_dynamicfields.length) {
            let dynamicValueAssign = [...project_dynamicfields]

            if (props.data) {
                if (props.data.projectType) {
                    let projectType = props.data.projectType
                    dynamicValueAssign =
                        projectType === 3
                            ? dynamicValueAssign.filter(
                                  (item) => item.show_group !== 2
                              )
                            : projectType === 2
                            ? dynamicValueAssign.filter(
                                  (item) => item.show_group !== 3
                              )
                            : dynamicValueAssign
                }
            }
            dynamicValueAssign.push(
                {
                    name: 'market_status',
                    value: 'draft',
                    type: 'default',
                    active: 1,
                },
                {
                    name: 'auctiontype',
                    value: 'live',
                    type: 'default',
                    active: 1,
                }
            )

            console.log('dynamicValueAssign', dynamicValueAssign)
            setFieldValue(dynamicValueAssign)
        }
    }, [project_dynamicfields, props.data])

    const closeFunction = () => {
        history.goBack()
    }

    const additionalFieldUpdate = (data) => {
        setUpdatedValues(data)
    }
    return (
        <>
            <Layout>
                <ProductFieldsView
                    fieldValue={fieldValue}
                    showasin={global?.showasin ? global.showasin : false}
                    userId={props.userId}
                    data={data}
                    function={closeFunction}
                    additionalFieldUpdate={additionalFieldUpdate}
                    closeFunction={closeFunction}
                    standalone={global?.standalone ? global?.standalone : false}
                />
            </Layout>
        </>
    )
}

export default DynamicListing
